class ProgramList extends Component {
    constructor(el) {
        super(el);
        this.monthFilterButtons = document.querySelectorAll('[data-month-filter-button]');
        this.resultContainer = document.querySelector('[data-ajax-results]');
        this.schoolFilterButtons = document.querySelectorAll('[data-schoolFilter-button]');
        this.playedButton = document.querySelector('[data-playedFilter-button]');
        this.monthsContainer = document.querySelector('[data-months-container]');
        this.chevronLeft = document.querySelector('[data-months-chevron-left]');
        this.chevronRight = document.querySelector('[data-months-chevron-right]');

        this.isDown = false;
        this.startX = 0;
        this.scrollLeft = 0;
        this.hasMoved = false;

        this.addEventListeners();
        this.updateChevrons();
        this.restoreScrollPosition();
    }

    updateProgram(program) {
        if (this.resultContainer) {
            const currentScroll = this.monthsContainer ? this.monthsContainer.scrollLeft : 0;
            this.resultContainer.outerHTML = program;
            Component.initComponents();
            this.updateChevrons();
            this.restoreScrollPosition(currentScroll);
        }
    }

    restoreScrollPosition(value = null) {
        if (!this.monthsContainer) return;

        let scrollPos = value;
        if (scrollPos === null) {
            scrollPos = sessionStorage.getItem('inscenaceDateListScroll');
        }

        if (scrollPos !== null) {
            this.monthsContainer.style.scrollBehavior = 'auto';
            this.monthsContainer.scrollLeft = scrollPos;
            this.monthsContainer.style.scrollBehavior = '';
        }
    }

    saveScrollPosition() {
        if (this.monthsContainer) {
            sessionStorage.setItem('inscenaceDateListScroll', this.monthsContainer.scrollLeft);
        }
    }

    loadProgram(url) {
        EventBus.getInstance().dispatchEvent("showGlobalSpinner");
        fetch(url + (url.includes('?') ? '&' : '?') + 'ajax=yes')
            .then(response => response.json())
            .then(data => {
                if (data.status === 'OK') this.onSuccess(data, url);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    onSuccess(data, url) {
        history.pushState(null, null, url);
        this.$el.removeAttribute('data-initialized');
        this.updateProgram(data.programHTML);
        EventBus.getInstance().dispatchEvent("hideGlobalSpinner");
    }

    buttonSetActive(button) {
        this.schoolFilterButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
    }

    updateChevrons() {
        if (!this.monthsContainer || !this.chevronLeft || !this.chevronRight) return;

        const { scrollLeft, scrollWidth, clientWidth } = this.monthsContainer;
        const canScroll = scrollWidth > clientWidth;

        if (!canScroll) {
            this.chevronLeft.classList.add('is-hidden');
            this.chevronRight.classList.add('is-hidden');
            return;
        }

        this.chevronLeft.classList.remove('is-hidden');
        this.chevronRight.classList.remove('is-hidden');

        const atStart = scrollLeft <= 1;
        const atEnd = Math.abs(scrollWidth - clientWidth - scrollLeft) <= 1;

        this.chevronLeft.classList.toggle('is-disabled', atStart);
        this.chevronRight.classList.toggle('is-disabled', atEnd);
    }

    addEventListeners() {
        this.monthFilterButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                if (this.hasMoved) {
                    e.preventDefault();
                    return;
                }
                this.saveScrollPosition();
                this.loadProgram(button.dataset.url);
            })
        });

        this.playedButton && this.playedButton.addEventListener('click', e => {
            this.saveScrollPosition();
            this.loadProgram(e.target.dataset.filterUrl);
        });

        this.schoolFilterButtons.forEach(schoolFilterButton => {
            schoolFilterButton.addEventListener('click', () => {
                this.buttonSetActive(schoolFilterButton);
            });
            schoolFilterButton.addEventListener('click', () => {
                this.saveScrollPosition();
                this.loadProgram(schoolFilterButton.dataset.filterUrl);
            });
        })

        if (this.monthsContainer) {
            this.chevronLeft && this.chevronLeft.addEventListener('click', () => {
                this.monthsContainer.scrollLeft -= 200;
                this.saveScrollPosition();
            });

            this.chevronRight && this.chevronRight.addEventListener('click', () => {
                this.monthsContainer.scrollLeft += 200;
                this.saveScrollPosition();
            });

            this.monthsContainer.addEventListener('scroll', () => {
                this.updateChevrons();
                this.saveScrollPosition();
            });
            window.addEventListener('resize', () => this.updateChevrons());

            this.monthsContainer.addEventListener('mousedown', (e) => {
                this.isDown = true;
                this.hasMoved = false;
                this.monthsContainer.classList.add('is-dragging');
                this.startX = e.pageX - this.monthsContainer.offsetLeft;
                this.scrollLeft = this.monthsContainer.scrollLeft;

                this.monthsContainer.style.scrollBehavior = 'auto';
            });

            this.monthsContainer.addEventListener('mouseleave', () => {
                this.isDown = false;
                this.monthsContainer.classList.remove('is-dragging');
                this.monthsContainer.style.scrollBehavior = '';
                this.saveScrollPosition();
            });

            this.monthsContainer.addEventListener('mouseup', () => {
                this.isDown = false;
                this.monthsContainer.classList.remove('is-dragging');
                this.monthsContainer.style.scrollBehavior = '';
                this.saveScrollPosition();
            });

            this.monthsContainer.addEventListener('mousemove', (e) => {
                if (!this.isDown) return;
                e.preventDefault();
                const x = e.pageX - this.monthsContainer.offsetLeft;
                const walk = (x - this.startX) * 2;
                if (Math.abs(walk) > 5) {
                    this.hasMoved = true;
                }
                this.monthsContainer.scrollLeft = this.scrollLeft - walk;
            });
        }
    }
}
